export default __webpack_public_path__ + "static/media/logo-small.bac61912.svg";